import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import Graphic from "@arcgis/core/Graphic";
import PopupTemplate from "@arcgis/core/PopupTemplate";
import { AppConfig } from "../../../app.config";
import Collection from "@arcgis/core/core/Collection";
export let SearchComponent = class SearchComponent {
    constructor() { }
    getCustomSources() {
        const sources = new Collection();
        if (AppConfig.settings.customGeolocators.length > 0) {
            AppConfig.settings.customGeolocators.forEach((geoLocator) => {
                this.addLocatorSource(geoLocator, sources);
            });
        }
        return sources;
    }
    searchMultipleResults(event, mapView) {
        const memoryCollection = [];
        let extMaxX = -180;
        let extMinX = 180;
        let extMaxY = -90;
        let extMinY = 90;
        let counter = 0;
        mapView.popup.clear();
        mapView.popup.close();
        const pointGraphics = [];
        try {
            event.results.forEach((entry) => {
                entry.results.forEach((res) => {
                    let x;
                    let y;
                    if (res.feature.geometry.type === "point") {
                        // @ts-ignore
                        x = res.feature.geometry.longitude;
                        // @ts-ignore
                        y = res.feature.geometry.latitude;
                    }
                    else {
                        // @ts-ignore
                        x = res.feature.geometry.centroid.longitude;
                        // @ts-ignore
                        y = res.feature.geometry.centroid.latitude;
                    }
                    if (x > extMaxX && x !== 0 && x <= 180) {
                        extMaxX = x;
                    }
                    if (y > extMaxY && y !== 0 && y <= 90) {
                        extMaxY = y;
                    }
                    if (x < extMinX && x !== 0 && x >= -180) {
                        extMinX = x;
                    }
                    if (y < extMinY && y !== 0 && y >= -90) {
                        extMinY = y;
                    }
                    memoryCollection[counter] = [res.feature.attributes, res.feature.geometry, x, y, res.extent,
                        res.feature.attributes.Loc_name, counter, res.name];
                    counter++;
                });
            });
        }
        catch (e) {
            if (e)
                throw e;
        }
        const markerSymbol = {
            type: "simple-marker",
            color: [39, 111, 139],
            size: 15,
            outline: {
                color: [255, 255, 255],
                width: 2
            }
        };
        for (let i = 0; i < counter; i++) {
            const point = {
                type: "point",
                longitude: memoryCollection[i][2],
                latitude: memoryCollection[i][3]
            };
            const template = new PopupTemplate({
                title: memoryCollection[i][7] + "<div class='report-button' style='cursor: pointer' onclick='generateReport(" + point.longitude + "," + point.latitude + ",\"" + memoryCollection[i][7] + "\"," + memoryCollection[i][0].Postal + ")'><u><b><i>Generate Report</i></b></u></div>"
            });
            const pointGraphic = new Graphic({
                // @ts-ignore
                geometry: point,
                // @ts-ignore
                symbol: markerSymbol,
                popupTemplate: template
            });
            pointGraphics.push(pointGraphic);
        }
        // @ts-ignore
        mapView.center = [memoryCollection[0][2], memoryCollection[0][3]];
        mapView.zoom = 11;
    }
    addLocatorSource(locatorSearchSource, searchSources) {
        // const locator = new Locator({
        //  url: locatorSearchSource.url
        // })
        searchSources.add({
            url: locatorSearchSource.url,
            name: locatorSearchSource.name,
            countryCode: locatorSearchSource.countryCode
        });
    }
    static ctorParameters = () => [];
};
SearchComponent = __decorate([
    Injectable({
        providedIn: "root"
    })
], SearchComponent);
